

import React, { createContext, useEffect, useState } from 'react'
import AxiosApi, { PASS_KEY, WEB_KEY,BaseUrl} from '../api/AxiosApi';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';

export const InverterContext = createContext()
export function InverterProvider({ children }) {
    const [InvChartLoading, setInvChartLoading] = useState(false)
    const [InverterChartData, setInverterChartData] = useState([])

    const [InvChartLoading2, setInvChartLoading2] = useState(false)
    const [InverterChartData2, setInverterChartData2] = useState([])

    const [InvChartLoadingSummary, setInvChartLoadingSummary] = useState(false)
    const [InverterChartDataSummary, setInverterChartDataSummary] = useState([])


    const [HYBRD_DATA, setHYBRD_DATA] = useState([])
    const [HYBRD_DATA_POWER_Loading, setHYBRD_DATA_POWER_Loading] = useState(false)

    const [HYBRD_DATA_POWER, setHYBRD_DATA_POWER] = useState([])

    const [HYBRD_DATA_INFO, setHYBRD_DATA_INFO] = useState([])// THIS IS FOR CHART

    const [HYBRD_MORE_DATA, setHYBRD_MORE_DATA] = useState([])
    const [HYBRD_LOADING, setHYBRD_LOADING] = useState(false)
    const [EnergyKwhOverviewData, setEnergyKwhOverviewData] = useState([])

    const [POST_KWH_HYBRID_DATA, setPOST_KWH_HYBRID_DATA] = useState([])// this api for mainTop

    const [POST_KWH_LOADING, setPOST_KWH_LOADING] = useState(false)
    const [POST_KWH_HYBRID_DATA_DASHBOARD, setPOST_KWH_HYBRID_DATA_DASHBOARD] = useState([])

    const [HYBRD_CONTROLS_DATA, setHYBRD_CONTROLS_DATA] = useState(null)
    const [HYBRD_CONTROLS_LOADING, setHYBRD_CONTROLS_LOADING] = useState(false)

    const [HYBRD_SET_VALUES_DATA, setHYBRD_SET_VALUES_DATA] = useState(null)
    const [HYBRD_SETVALUE_LOADING, setHYBRD_SETVALUE_LOADING] = useState(false)

    const [HYBRD_CONTROLS_LOG_DATA, setHYBRD_CONTROLS_LOG_DATA] = useState([])
    const [HYBRD_CONTROLS_LOG_DATA_LOADING, setHYBRD_CONTROLS_LOG_DATA_LOADING] = useState(false)

    // this is for Hourlyapi
    const [hourlyData, setHourlyData] = useState(null);
    const [hourlyLoading, setHourlyLoading] = useState(false);
    const [hourlyError, setHourlyError] = useState(null);

     // this is for Hourlyapi PLANT
     const [hourlyData2, setHourlyData2] = useState(null);
     const [hourlyLoading2, setHourlyLoading2] = useState(false);
     const [hourlyError2, setHourlyError2] = useState(null);

    //this is for MonthlyApi(energyreporting)
    const [monthlyData, setMonthlyData] = useState(null);
    const [monthlyLoading, setMonthlyLoading] = useState(false);
    const [monthlyError, setMonthlyError] = useState(null);

    //this is for MonthlyApi PLANT (energyreporting)
    const [monthlyData2, setMonthlyData2] = useState(null);
    const [monthlyLoading2, setMonthlyLoading2] = useState(false);
    const [monthlyError2, setMonthlyError2] = useState(null);

    function getInverterChartData(LCODE, DT1, DT2) {
        setInvChartLoading(true)
        let headersList = {
            "Accept": "/",
            "Content-Type": "application/x-www-form-urlencoded"
        }
        let bodyContent = `LCODE=${LCODE}&DT1=${DT1}&DT2=${DT2}`;
        AxiosApi.post('POWER/post_KWH_IRR', bodyContent, headersList)
            .then((res) => {
                setInverterChartData(res?.data?.KWH_MIS)
                // console.log('InvTableSuccess', res?.data?.KWH_MIS)
                setInvChartLoading(false)
            }).catch((er) => {
                // alert('record not found')
                console.log('fetInvErrorChart', er)
                setInvChartLoading(false)
            });

    }


    // dailyenergySummary

    function getInverterChartDataSummary(LCODE, DT1, DT2) {
        setInvChartLoading(true)
        let headersList = {
            "Accept": "/",
            "Content-Type": "application/x-www-form-urlencoded"
        }
        let bodyContent = `LCODE=${LCODE}&DT1=${DT1}&DT2=${DT2}`;
        AxiosApi.post('Power/post_KWH_IRR_SUM', bodyContent, headersList)
            .then((res) => {
                setInverterChartDataSummary(res?.data?.KWH_MIS_SUM)
                // console.log('InvTableSuccess', res?.data?.KWH_MIS)
                setInvChartLoadingSummary(false)
            }).catch((er) => {
                // alert('record not found')
                console.log('fetInvErrorChart', er)
                setInvChartLoadingSummary(false)
            });

    }
    

    function getInverterChartData2(LOGIN_ID, LCODE, PASS_KEY, WEB_KEY, TYP, DT1, DT2, SUB_PLANT) {
        setInvChartLoading2(true);
    
        // Headers
        const headersList = {
            "Accept": "*/*",
            "Content-Type": "application/x-www-form-urlencoded"
        };
    
        // Safe & clean request body
        const bodyParams = new URLSearchParams({
            LOGIN_ID,
            LCODE,
            PASS_KEY,
            WEB_KEY,
            TYP,
            DT1,
            DT2,
            SUB_PLANT
        }).toString();
    
        // console.log(":bodyContent", bodyParams);
    
        // Axios request with proper config object
        AxiosApi.post('CMN_04_SUB/post_KWH_IRR_SUB', bodyParams, {
            headers: headersList
        })
        .then((res) => {
            setInverterChartData2(res?.data?.KWH_MIS || []);
            setInvChartLoading2(false);
        })
        .catch((error) => {
            console.error('fetchInvErrorChart', error);
            setInvChartLoading2(false);
        });
    }
    



    function getGridLoadData(LCODE) {
        let headersList = {
            "Accept": "/",
            "Content-Type": "application/x-www-form-urlencoded"
        }
        // let bodyContent = `LCODE=${LCODE}`;
        AxiosApi.get(`Power/GET_TOT_LIVE_KW_NEW?LCODE=${LCODE}`, headersList)
            .then((res) => {
                // setInverterChartData(res?.data)
                // console.log('SuccessGridLoad', res.data)
                // setInvChartLoading(false)
            }).catch((er) => {
                console.log('fetGridLoadError', er)
                // setInvChartLoading(false)
            });

    }

    function getHYBRD(LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, TYP, IROW, DT1, DT2) {
        // console.log('getHYBRD.............')
        setHYBRD_LOADING(true)
        let headersList = {
            "Accept": "/",
            "Content-Type": "application/x-www-form-urlencoded"
        }
        AxiosApi.get(`CMN_03/Get_HYBRD?LOGIN_ID=${LOGIN_ID}&LOC_CODE=${LOC_CODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}&TYP=${TYP}&IROW=${IROW}&DT1=${DT1}&DT2=${DT2}`, headersList)
            .then((res) => {
                setHYBRD_DATA(res?.data?.HYBRD[0])
                // console.log('DATAAaaaaa', res?.data)
                setHYBRD_LOADING(false)
            }).catch((e) => {
                console.log('getHYBRD_ERROR', e)
                setHYBRD_LOADING(false)
            }).finally(() => {
                setHYBRD_LOADING(false)

            })
    }

    function getHYBRD_Power(LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, TYP, IROW, DT1, DT2) {
        // console.log('getHYBRDPOWER_PARMAS', { LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, TYP, IROW, DT1, DT2 })
        setHYBRD_DATA_POWER_Loading(true)

        let headersList = {
            "Accept": "/",
            "Content-Type": "application/x-www-form-urlencoded"
        }
        AxiosApi.get(`CMN_03/Get_HYBRD?LOGIN_ID=${LOGIN_ID}&LOC_CODE=${LOC_CODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}&TYP=${TYP}&IROW=${IROW}&DT1=${DT1}&DT2=${DT2}`, headersList)
            .then((res) => {
                setHYBRD_DATA_POWER(res?.data?.HYBRD)
                // console.log('HYBRD_POWER_DATA', res?.data)
                setHYBRD_DATA_POWER_Loading(false)

            }).catch((e) => {
                console.log('getHYBRD_ERROR', e)
                setHYBRD_DATA_POWER_Loading(false)

            }).finally(() => {

            })
    }

    // THIS API FOR CHART

    function getHYBRD_Info(LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, TYP, IROW, DT1, DT2) {
        // console.log('getHYBRDPOWER_INFo', { LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, TYP, IROW, DT1, DT2 })
        let headersList = {
            "Accept": "/",
            "Content-Type": "application/x-www-form-urlencoded"
        }
        AxiosApi.get(`CMN_03/Get_HYBRD?LOGIN_ID=${LOGIN_ID}&LOC_CODE=${LOC_CODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}&TYP=${TYP}&IROW=${IROW}&DT1=${DT1}&DT2=${DT2}`, headersList)
            .then((res) => {
                setHYBRD_DATA_INFO(res?.data?.HYBRD[0])
                // console.log('HYBRD_POWER_INFO', res?.data)
            }).catch((e) => {
                console.log('getHYBRD_ERROR', e)
            }).finally(() => {

            })
    }


    function getHYBRDwithZero(LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, TYP, IROW, DT1, DT2) {
        // console.log('getHYBRDwithZero.................')
        // setHYBRD_LOADING(true)
        // console.log('params', { LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, TYP, IROW, DT1, DT2 })
        let headersList = {
            "Accept": "/",
            "Content-Type": "application/x-www-form-urlencoded"
        }
        AxiosApi.get(`CMN_03/Get_HYBRD?LOGIN_ID=${LOGIN_ID}&LOC_CODE=${LOC_CODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}&TYP=${TYP}&IROW=${IROW}&DT1=${DT1}&DT2=${DT2}`, headersList)
            .then((res) => {
                setHYBRD_MORE_DATA(res?.data?.HYBRD)
                // console.log('DATAwith0', res?.data)
                // setHYBRD_LOADING(false)
            }).catch((e) => {
                console.log('getHYBRD_ERROR', e)
                // setHYBRD_LOADING(false)
            }).finally(() => {
                // setHYBRD_LOADING(false)

            })
    }

    function getPostKwhHybrid(LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, TYP, DT1, DT2) {
        // console.log('getPostKwhHybridParams', { LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, TYP, DT1, DT2 })
        setPOST_KWH_LOADING(true)
        let headersList = {
            "Accept": "/",
            "Content-Type": "application/x-www-form-urlencoded"
        }
        let bodyContent = `LOGIN_ID=${LOGIN_ID}&LCODE=${LOC_CODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}&TYP=${TYP}&DT1=${DT1}&DT2=${DT2}`
        AxiosApi.post(`https://log.solaramr.com/API/CMN_03/POST_KWH_HYBRID`, bodyContent, headersList)
            .then((res) => {
                setPOST_KWH_HYBRID_DATA(res?.data?.KWH_HYBRID)
                // console.log('api', res?.data)
                // setPOST_KWH_LOADING(false)
            }).catch((e) => {
                console.log('getHYBRD_ERROR', e)
                // setPOST_KWH_LOADING(false)
            }).finally(() => {
                // setPOST_KWH_LOADING(false)

            })
    }

    function getPostKwhHybridEnergyOverview(LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, TYP, DT1, DT2) {
        // console.log('getPostKwhHybridEnergyOverview', { LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, TYP, DT1, DT2 })
        // setPOST_KWH_LOADING(true)
        let headersList = {
            "Accept": "/",
            "Content-Type": "application/x-www-form-urlencoded"
        }
        let bodyContent = `LOGIN_ID=${LOGIN_ID}&LCODE=${LOC_CODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}&TYP=${TYP}&DT1=${DT1}&DT2=${DT2}`
        AxiosApi.post(`https://log.solaramr.com/API/CMN_03/POST_KWH_HYBRID`, bodyContent, headersList)
            .then((res) => {
                setEnergyKwhOverviewData(res?.data?.KWH_HYBRID)
                // console.log('api', res?.data)
                // setPOST_KWH_LOADING(false)
            }).catch((e) => {
                console.log('getHYBRD_ERROR', e)
                // setPOST_KWH_LOADING(false)
            }).finally(() => {
                // setPOST_KWH_LOADING(false)

            })
    }


    // THIS API FOR DASHBOARD (MAIN)
    function getPostKwhHybridForDashboard(LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, TYP, DT1, DT2) {
        // console.log('getPostKwhHybridParams', { LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, TYP, DT1, DT2 })
        // setPOST_KWH_LOADING(true)
        let headersList = {
            "Accept": "/",
            "Content-Type": "application/x-www-form-urlencoded"
        }
        let bodyContent = `LOGIN_ID=${LOGIN_ID}&LCODE=${LOC_CODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}&TYP=${TYP}&DT1=${DT1}&DT2=${DT2}`
        AxiosApi.post(`https://log.solaramr.com/API/CMN_03/POST_KWH_HYBRID`, bodyContent, headersList)
            .then((res) => {
                setPOST_KWH_HYBRID_DATA_DASHBOARD(res?.data?.KWH_HYBRID[0])
                // console.log('apiDash', res?.data)
                // setPOST_KWH_LOADING(false)
            }).catch((e) => {
                console.log('getHYBRD_ERROR', e)
                // setPOST_KWH_LOADING(false)
            }).finally(() => {
                // setPOST_KWH_LOADING(false)

            })
    }


    function getHYBRDControls(LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, TYP, IROW, DT1, DT2) {
        // console.log('getHYBRD.............')
        setHYBRD_CONTROLS_LOADING(true)
        let headersList = {
            "Accept": "/",
            "Content-Type": "application/x-www-form-urlencoded"
        }
        AxiosApi.get(`CMN_03/Get_HYBRD?LOGIN_ID=${LOGIN_ID}&LOC_CODE=${LOC_CODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}&TYP=${TYP}&IROW=${IROW}&DT1=${DT1}&DT2=${DT2}`, headersList)
            .then((res) => {
                setHYBRD_CONTROLS_DATA(res?.data?.HYBRD[0])
                // console.log('Controlls', res?.data)
                setHYBRD_CONTROLS_LOADING(false)
            }).catch((e) => {
                console.log('getHYBRD_ERROR', e)
                setHYBRD_CONTROLS_LOADING(false)
            }).finally(() => {
                setHYBRD_CONTROLS_LOADING(false)

            })
    }
    function getHYBRDsetValues(LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, TYP, IROW, DT1, DT2) {
        // console.log('getHYBRD.............')
        setHYBRD_SETVALUE_LOADING(true)
        let headersList = {
            "Accept": "/",
            "Content-Type": "application/x-www-form-urlencoded"
        }
        AxiosApi.get(`CMN_03/Get_HYBRD?LOGIN_ID=${LOGIN_ID}&LOC_CODE=${LOC_CODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}&TYP=${TYP}&IROW=${IROW}&DT1=${DT1}&DT2=${DT2}`, headersList)
            .then((res) => {
                setHYBRD_SET_VALUES_DATA(res?.data?.HYBRD[0])
                // console.log('DATAAaaaaa', res?.data)
                setHYBRD_SETVALUE_LOADING(false)
            }).catch((e) => {
                console.log('getHYBRD_ERROR', e)
                setHYBRD_SETVALUE_LOADING(false)
            }).finally(() => {
                setHYBRD_SETVALUE_LOADING(false)

            })
    }

    function getHYBRD_Control_Log1(LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, TYP, IROW, DT1, DT2) {
        // console.log('LOGPARAMS', { LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, TYP, IROW, DT1, DT2 })
        setHYBRD_CONTROLS_LOG_DATA_LOADING(true)
        let headersList = {
            "Accept": "/",
            "Content-Type": "application/x-www-form-urlencoded"
        }
        AxiosApi.get(`CMN_03/Get_HYBRD?LOGIN_ID=${LOGIN_ID}&LOC_CODE=${LOC_CODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}&TYP=${TYP}&IROW=${IROW}&DT1=${DT1}&DT2=${DT2}`, headersList)
            .then((res) => {
                setHYBRD_CONTROLS_LOG_DATA(res?.data?.HYBRD)
                // console.log('LOG', res?.data)
                setHYBRD_CONTROLS_LOG_DATA_LOADING(false)
            }).catch((e) => {
                console.log('getHYBRD_ERROR', e)
                setHYBRD_CONTROLS_LOG_DATA_LOADING(false)
            }).finally(() => {
                setHYBRD_CONTROLS_LOG_DATA_LOADING(false)

            })
    }

    // THIS IS HOURLYAPI(energyreporting)

    const HourlyApi = async ({ LOGIN_ID, PASS_KEY, LCODE, DT1, DT2, TYP, WEB_KEY, FID }) => {
       
        // Construct the form data for the x-www-form-urlencoded request
        const formData = new URLSearchParams({
            LOGIN_ID,
            PASS_KEY,
            LCODE,
            DT1,
            DT2,
            TYP,
            WEB_KEY,
            FID
        });

        const config = {
            method: "POST",
            url: `${BaseUrl}CMN_04/post_KWH_HOUR`,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            data: formData.toString(),
        };

        try {
            setHourlyLoading(true); // Start loading
            setHourlyError(null); // Reset error
            const response = await axios(config);

            // Assuming data is returned in the `response.data` object
            setHourlyData(response?.data?.KWH_MIS_HOUR_NEW);

            // console.log("hourly", response?.data?.KWH_MIS_HOUR_NEW)

        } catch (error) {
            console.error("HourlyApi Error:", error);
            setHourlyError(error);
        } finally {
            setHourlyLoading(false); // End loading
        }
    };


    //THIS API FOR PLANT HOURLY

    const HourlyPlant1Api = async ({ LOGIN_ID, PASS_KEY, LCODE, DT1, DT2, TYP, WEB_KEY, FID,SUB_PLANT }) => {
       
        // Construct the form data for the x-www-form-urlencoded request
        const formData = new URLSearchParams({
            LOGIN_ID,
            PASS_KEY,
            LCODE,
            DT1,
            DT2,
            TYP,
            WEB_KEY,
            FID,
            SUB_PLANT
        });

        const config = {
            method: "POST",
            url: `${BaseUrl}CMN_04_SUB/post_KWH_HOUR_SUB`,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            data: formData.toString(),
        };

        try {
            setHourlyLoading2(true); // Start loading
            setHourlyError2(null); // Reset error
            const response = await axios(config);

            // Assuming data is returned in the `response.data` object
            setHourlyData2(response?.data?.KWH_MIS_HOUR_NEW);

            // console.log("hourly", response?.data?.KWH_MIS_HOUR_NEW)

        } catch (error) {
            console.error("HourlyApi Error:", error);
            setHourlyError2(error);
        } finally {
            setHourlyLoading2(false); // End loading
        }
    };

    //THIS IS MONTHLY API(energy reporting)
    const MonthlyApi = async ({ LOGIN_ID, PASS_KEY, LCODE, MT1, MT2, TYP, WEB_KEY, FID }) => {
      
        // Construct the query parameters dynamically
        const params = new URLSearchParams({
            LOGIN_ID,
            PASS_KEY,
            LCODE,
            MT1,
            MT2,
            TYP,
            WEB_KEY,
            FID,
        });

        const config = {
            method: "GET",
            url: `${BaseUrl}CMN_04/GET_MONTH_KWH?${params}`,

            
        };
        // console.log("url",config.url)
        try {
            setMonthlyLoading(true); // Start loading
            setMonthlyError(null); // Reset error

            const response = await axios(config);

            // Assuming data is returned in the `response.data` object
            setMonthlyData(response?.data?.MONTH);

            // console.log("monthly", response?.data?.MONTH);
        } catch (error) {
            console.error("MonthlyApi Error:", error);
            setMonthlyError(error);
        } finally {
            setMonthlyLoading(false); // End loading
        }
    };

    //THIS IS MONTHLYSUM API(energy reporting)
    const MonthlyPlant1Api = async ({ LOGIN_ID, PASS_KEY, LCODE, MT1, MT2, TYP, WEB_KEY, FID,SUB_PLANT }) => {
        // Construct the query parameters dynamically
        const params = new URLSearchParams({
            LOGIN_ID, PASS_KEY, LCODE, MT1, MT2, TYP, WEB_KEY, FID,SUB_PLANT
        });

        const config = {
            method: "GET",
            url: `${BaseUrl}CMN_04_SUB/GET_MONTH_KWH_SUB?${params}`,

            
        };
        // console.log("url",config.url)
        try {
            setMonthlyLoading2(true); // Start loading
            setMonthlyError2(null); // Reset error

            const response = await axios(config);

            // Assuming data is returned in the `response.data` object
            setMonthlyData2(response?.data?.MONTH);

            // console.log("monthly", response?.data?.MONTH);
        } catch (error) {
            console.error("MonthlyApi Error:", error);
            setMonthlyError2(error);
        } finally {
            setMonthlyLoading2(false); // End loading
        }
    };
    return (

<InverterContext.Provider value={{ getHYBRD_Control_Log1, HYBRD_CONTROLS_LOG_DATA, HYBRD_CONTROLS_LOG_DATA_LOADING, getHYBRDControls, getHYBRDsetValues, HYBRD_SETVALUE_LOADING, HYBRD_SET_VALUES_DATA, HYBRD_CONTROLS_DATA, HYBRD_CONTROLS_LOADING, HYBRD_DATA_POWER_Loading, getHYBRD_Info, HYBRD_DATA_INFO, getHYBRD_Power, HYBRD_DATA_POWER, getPostKwhHybridEnergyOverview, EnergyKwhOverviewData, POST_KWH_HYBRID_DATA_DASHBOARD, getPostKwhHybridForDashboard, getPostKwhHybrid, POST_KWH_HYBRID_DATA, HYBRD_MORE_DATA, getHYBRDwithZero, getHYBRD, HYBRD_DATA, HYBRD_LOADING, getGridLoadData, InvChartLoading, getInverterChartData, InverterChartData, InvChartLoading2, getInverterChartData2, InverterChartData2, hourlyData, hourlyLoading, hourlyError, HourlyApi ,monthlyData,monthlyLoading,monthlyError,MonthlyApi,monthlyData2,monthlyLoading2,monthlyError2,MonthlyPlant1Api, hourlyData2, hourlyLoading2, hourlyError2, HourlyPlant1Api,InverterChartDataSummary,getInverterChartDataSummary}}>
            {children}
        </InverterContext.Provider>
    )
}
